export const valueParser = (value: any) => value.length ? value : false;
